import DuckModule from '../duckModule';

export default DuckModule({
    store: 'filtro-licenze',
    initialState: {
        currentSelection: 0,
        selection: [],
        selectedRowIndex: -1,
        selected_license: {},
        filters: [],
        sorting: [{ columnName: 'totaleAttivita', direction: 'desc' }],
        hiddenColumnNames: [
            'HW_ID',
            'NumeroReinstallazioni',
            'DataUltimoAccesso',
            'DataCreazione',
            'DataAttivazione'
        ],
        currentPage: 0,
        pageSize: 15,
        pageSizes: [5, 15, 25, 50, 100],
        expandedRowIds: [],
        columnWidths: [
            { columnName: 'SerialNumber', width: 140 },
            { columnName: 'ProductKey', width: 280 },
            { columnName: 'Cliente', width: 220 },
            { columnName: 'Tipologia', width: 135 },
            { columnName: 'DataDecorr', width: 200 },
            { columnName: 'DataScadenza', width: 200 },
            { columnName: 'DataAttivazione', width: 200 },
            { columnName: 'Bloccata', width: 125 },
            { columnName: 'CodiceUtente', width: 195 },
            { columnName: 'MultiAzienda', width: 130 },
            { columnName: 'SerialNumberOld', width: 140 },
            { columnName: 'Email', width: 220 },
            { columnName: 'HW_ID', width: 155 },
            { columnName: 'NumeroReinstallazioni', width: 185 },
            { columnName: 'DataUltimoAccesso', width: 200 },
            { columnName: 'DataCreazione', width: 145 },
        ],
    },
    types: ['GRID_STATE_CHANGE', 'HANDLE_ROW_SELECTION', 'HANDLE_EXPANDED_ROW', 'RESET_FILTERS', 'SET_SELECTED_LICENSE'],
}).extend({
    reducer: (state, { type, payload }, { types }) => {
        switch (type) {
            case types.RESET_FILTERS:
                return {
                    ...state,
                    currentSelection: 0,
                    selection: [],
                    selectedRowIndex: -1,
                    selected_license: {},
                    filters: [],
                    currentPage: 0,
                };
            case types.GRID_STATE_CHANGE:
                return {
                    ...state,
                    [payload.newStateName]: payload.newStateValue,
                };


            case types.HANDLE_ROW_SELECTION:    //Posso selezionare solo una riga per volta
                const newIndex = payload.newSelection
                    .find(selected => state.selection.indexOf(selected) === -1);

                if (newIndex !== undefined)
                    return {
                        ...state,
                        selection: [newIndex],
                        selectedRowIndex: newIndex,
                    };
                else if (newIndex === undefined)
                    return {
                        ...state,
                        selection: [],
                        selectedRowIndex: -1,
                    };
                else return state;


            case types.SET_SELECTED_LICENSE:
                if (state.selectedRowIndex !== -1)
                    return {
                        ...state,
                        selected_license: payload.selected_license,
                    };
                else return {
                    ...state,
                    selected_license: {},
                };


            case types.HANDLE_EXPANDED_ROW:
                const newRowIndex = payload.newExpandedRow
                    .find(selected => state.expandedRowIds.indexOf(selected) === -1);

                if (newRowIndex !== undefined)
                    return {
                        ...state,
                        expandedRowIds: [newRowIndex],
                        selection: [newRowIndex],
                    };
                else if (newRowIndex === undefined)
                    return {
                        ...state,
                        expandedRowIds: [],
                    };
                else return state;
            default:
                return state;
        }
    },
    creators: ({ types }) => ({
        handleRowSelection: (newSelection) => ({
            type: types.HANDLE_ROW_SELECTION,
            payload: { newSelection },
        }),
        handleExpandedRow: newExpandedRow => ({
            type: types.HANDLE_EXPANDED_ROW,
            payload: { newExpandedRow },
        }),
        onGridAction: (newStateName, newStateValue) => ({
            type: types.GRID_STATE_CHANGE,
            payload: { newStateName, newStateValue },
        }),
        resetFilters: () => ({
            type: types.RESET_FILTERS,
        }),


        setSelectedLicense: (selected_license) => ({
            type: types.SET_SELECTED_LICENSE,
            payload: { selected_license },
        }),

    }),
});
